import {get} from '../washtraxClient';

const documentList = docType => {
  return get (`/get/assetWashOut/docs/${docType}`);
};
export default {
  documentList,
};
